export function getMenuSelectedKeys(pathname, menuEntries) {
    if (!pathname || !Array.isArray(menuEntries) || menuEntries.length === 0) {
        return [];
    }
    const sorted = [...menuEntries].sort((a, b) => b.key.length - a.key.length);
    const hit = sorted.find(row => pathname === row.key || pathname.startsWith(`${row.key}/`));
    return hit ? [hit.key] : [];
}
